exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n.heading-bar-title {\n  font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-3-1!./node_modules/less-loader/dist/cjs.js??ref--1-oneOf-3-2!./src/components/Modules/HeadingBar/headingBar.less
// module id = 1463
// module chunks = 0